import React from 'react';
import { clickOutletRow } from 'actions/outletPages/list';
import { askConfirmAction } from 'actions/confirm-action';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import styles from './Table.css';
import gobizLogoUrl from './gobiz-small.png';

class Table extends React.Component {
  render() {
    const { outlets } = this.props;
    const hasAssociatedOutlet = outlets.some(({ saudagar }) => !!saudagar);

    return (
      outlets.length > 0 && (
        <div className={styles.wrapper}>
          <table className={`table ${styles['table-header']}`}>
            <thead>
              <tr>
                {hasAssociatedOutlet && <th className={styles.gobizLogo} />}
                <th className={styles.name}>Outlet Name</th>
                <th className={styles.address}>Address</th>
                <th className={styles.phone}>Phone</th>
                <th className={styles.city}>City</th>
                <th className={styles.province}>Province</th>
                <th className={styles.status}>Status</th>
                <th className={styles.gobizid}>GoBiz ID</th>
              </tr>
            </thead>
          </table>
          <div className={`${styles.scroll} outlet-scroll`}>
            <table className={`table ${styles['table-body']}`}>
              <tbody className={styles.tbody}>
                {outlets.map(outlet =>
                  this._renderRow(outlet, hasAssociatedOutlet)
                )}
              </tbody>
            </table>
          </div>
        </div>
      )
    );
  }

  _renderRow = (outlet, hasAssociatedOutlet) => {
    const isAssociated = !!outlet.saudagar;

    return (
      <tr
        key={outlet.id}
        onClick={() => this._onClickOutlet(outlet)}
        className={this._isSelected(outlet) ? styles.selected : ''}
      >
        {hasAssociatedOutlet && (
          <td className={styles.gobizLogo}>
            {isAssociated && <img src={gobizLogoUrl} />}
          </td>
        )}
        <td className={styles.name}>
          {useMokaOutletPropsFirst(outlet, o => o.name)}
        </td>
        <td className={styles.address}>
          {useMokaOutletPropsFirst(outlet, o => o.address)}
        </td>
        <td className={styles.phone}>
          {useMokaOutletPropsFirst(outlet, o => o.phone_number)}
        </td>
        <td className={styles.city}>
          {useMokaOutletPropsFirst(outlet, o => o.city)}
        </td>
        <td className={styles.province}>
          {useMokaOutletPropsFirst(outlet, o => o.province)}
        </td>
        <td className={styles.status}>{this._renderOutletStatus(outlet)}</td>
        <td className={styles.gobizid}>{outlet.saudagar_id}</td>
      </tr>
    );
  };

  _renderOutletStatus = outlet => {
    const endDate = moment(outlet.end_date);
    const todayDate = moment();
    if (endDate.isSameOrAfter(todayDate)) {
      return <span className={styles['outlet-active']}>Active</span>;
    }
    return <span className={styles['outlet-inactive']}>Expired</span>;
  };

  _onClickOutlet = outlet => {
    const { isDirtyForm, dispatch } = this.props;
    if (isDirtyForm) {
      dispatch(askConfirmAction(clickOutletRow(outlet.id)));
    } else {
      dispatch(clickOutletRow(outlet.id));
    }
  };

  _isSelected = outlet => {
    const { outletDetail } = this.props;
    return outletDetail && outlet.id === outletDetail.id;
  };
}

Table.propTypes = {
  outlets: PropTypes.array,
  dispatch: PropTypes.func,
  outletDetail: PropTypes.object,
  isDirtyForm: PropTypes.bool,
  loggedInEmail: PropTypes.string,
};

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return { showLoadingSpinnerPage };
}

export default connect(mapStateToProps)(Table);
